import { render } from "./adminPerfilesForm-Component.vue?vue&type=template&id=2c92ed1b"
import script from "./adminPerfilesForm-Component.vue?vue&type=script&lang=js"
export * from "./adminPerfilesForm-Component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__